import {
    BaseSubChartProperty,
} from '@src/slide/domain/ui-model/element-modeles/property/chart/sub-chart/base-sub-chart';
import { DataLabelProperty } from '@src/slide/domain/ui-model/element-modeles/property/chart/sub-chart/data-label';
import { STDLblPos, SubChartType } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/sdk-model.interface';
import { getFormattedNumber } from '../util/format';
import type { ISubChartModel, IPieChart } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/sub-chart';
import type { LegendContentType, ILegendItem } from '@src/slide/domain/ui-model/element-modeles/property/chart/legend/legend.interface';
import type {
    IPieChartProperty,
} from '@src/slide/domain/ui-model/element-modeles/property/chart/sub-chart/pie-chart.interface';
import type {
    IDataLabel,
} from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/sub-chart/sub-chart-properties.interface';
import { IDataItemProperty } from './data-item/data-item.interface';

export class PieChartProperty<
    IChartData extends IPieChart = IPieChart
> extends BaseSubChartProperty<IChartData> implements IPieChartProperty {
    public get firstSliceAngle(): number {
        return this.uiData.firstSliceAngle ?? 0;
    }

    /* 饼图只按类别做图例 */
    public getLegendContentType(): LegendContentType {
        return 'category';
    }

    public processLegendItems(items: ILegendItem[]): ILegendItem[] {
        const firstSeries = this.series?.[0];

        // 还原图、饼图比较特殊，他们不按ser只按category，所以这里取第一个ser下的所有data做过滤
        return items
            .filter(dataItem => dataItem.ser.idx === firstSeries?.idx)
            .map((legendItem) => {
                let categoryText = legendItem.dataItem?.category || '';
                const categoryFormatCode = legendItem.dataItem?.categoryFormatCode;
                if (categoryFormatCode) {
                    categoryText = getFormattedNumber(categoryText, categoryFormatCode);
                }

                return {
                    ...legendItem,
                    name: categoryText as string,
                };
            });
    }

    public getDataLabelProperty(dataLabel: IDataLabel, dataItem: IDataItemProperty) {
        return new PieDataLabelProperty(dataLabel, this.context).init(dataItem);
    }

    public updateAngleOfFirstSlice(value: number, onlyChangeUI?: boolean) {
        const subChartModel = this.context.getSubChartModel() as IPieChart;
        if (subChartModel.originType !== SubChartType.PieChart
            && subChartModel.originType !== SubChartType.Pie3DChart) return;
        if (onlyChangeUI) {
            subChartModel.firstSliceAngle = value;
            return;
        }
        subChartModel.updateProps({ firstSliceAngle: value });
    }

    public getAngleOfFirstSlice(): number | undefined {
        const subChartModel = this.context.getSubChartModel() as IPieChart;
        if (subChartModel.originType !== SubChartType.PieChart
            && subChartModel.originType !== SubChartType.Pie3DChart) return;
        return subChartModel.firstSliceAngle;
    }

    // protected shouldApplyThemeStyle(uiData: any) {
    //     return !uiData?.props.style.fillBackground;
    // }
}

class PieDataLabelProperty extends DataLabelProperty {
    public get labelPosition(): STDLblPos {
        return this.uiData.labelPosition || STDLblPos.bestFit;
    }
}
